import { isMobile } from 'react-device-detect'
import api from '../utils/api'

class CasinoService {
  getCasinoList() {
    return api.get('get-casino-games')
  }

  getCasinoHomepageCategories() {
    return api.get('get-casino-homepage-categories')
  }

  getIntCasinoList(provider:any, type:any) {
    return api.get(`get-casino-int-games?provider=${provider}&type=${type}`)
  }

  getPublicIntCasinoList(provider: any, type: any) {
    const providerQuery =
      provider != null && provider !== '' ? `provider=${encodeURIComponent(String(provider))}&` : ''
    return api.get(`public-get-casino-int-games?${providerQuery}type=${encodeURIComponent(type)}`)
  }

  searchCasinoGames(searchQuery: string) {
    return api.get(`search-casino-games?query=${encodeURIComponent(searchQuery)}`)
  }

  searchPublicCasinoGames(searchQuery: string) {
    return api.get(`public-search-casino-games?query=${encodeURIComponent(searchQuery)}`)
  }

  getCasinoByHomepageCode(homepageCode: number) {
    return api.get(`get-casino-by-homepage/${homepageCode}`)
  }

  getplaycasino(data:any) {
    return api.post(`get-cas-casino-play-url`, data)
  }

  getCasinoDataById(id: any) {
    return api.get(`get-casino-data-by-id/${id}`)
  }

  getLiveCasinoData(slug: any) {
    return api.get(`${process.env.REACT_APP_CASINO_SOCKET_URL}api/get-casino-market/${slug}`)
  }

  getResultByMid(type: string, mid: string) {
    return api.get(
      `html-cards/${type}/${mid}/?ismobile=${isMobile}`,
    )
  }

  getResultList(filterdata: { matchid: string; startDate: string; roundId: string }, page: number) {
    return api.get(
      `done-results/${filterdata.matchid}?filter_date=${filterdata.startDate}&roundId=${filterdata.roundId}&page=${page}`,
    )
  }

  disableCasino(matchId: string) {
    return api.get(`disable-casino-games?matchId=${matchId}`)
  }

  // Get casino bet history with provider information
  getCasinoBetHistory(params?: { page?: number; limit?: number; startDate?: string; endDate?: string }) {
    const queryParams = new URLSearchParams()
    if (params?.page) queryParams.append('page', params.page.toString())
    if (params?.limit) queryParams.append('limit', params.limit.toString())
    if (params?.startDate) queryParams.append('startDate', params.startDate)
    if (params?.endDate) queryParams.append('endDate', params.endDate)
    
    return api.get(`casino-bet-history?${queryParams.toString()}`)
  }

  // Bets behind one casino account-statement row (own account)
  getCasinoStatementBets(params: { round?: string; betIds?: string[] }) {
    const queryParams = new URLSearchParams()
    if (params.round) queryParams.append('round', params.round)
    if (params.betIds?.length) queryParams.append('betIds', params.betIds.join(','))

    return api.get(`casino-statement-bets?${queryParams.toString()}`)
  }

  // Get casino account statement with provider breakdown
  getCasinoAccountStatement(params?: { startDate?: string; endDate?: string }) {
    const queryParams = new URLSearchParams()
    if (params?.startDate) queryParams.append('startDate', params.startDate)
    if (params?.endDate) queryParams.append('endDate', params.endDate)
    
    return api.get(`casino-account-statement?${queryParams.toString()}`)
  }

  getCasinoVisibilityConfig() {
    return api.get('casino-visibility-config')
  }

  getPublicCasinoVisibilityConfig() {
    return api.get('public-casino-visibility-config')
  }

  getHomeLiveCasinoGames() {
    return api.get('home-live-casino-games')
  }

  getHomeSlotsCasinoGames() {
    return api.get('home-slots-casino-games')
  }

  getRecommendedCasinoGames() {
    return api.get('recommended-casino-games')
  }

  getTrendingCasinoGames(presetSlug: string) {
    return api.get(`trending-casino-games/${encodeURIComponent(presetSlug)}`)
  }

  saveCasinoVisibilityConfig(config: any) {
    return api.post('save-casino-visibility-config', config)
  }

  uploadCasinoGameImage(gameId: string, file: File) {
    const formData = new FormData()
    formData.append('image', file)
    formData.append('gameId', gameId)
    return api.post('upload-casino-game-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }
}
export default new CasinoService()
